module.exports = __webpack_public_path__ + "static/img/man.ea833f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/man.png
// module id = mCPC
// module chunks = 2